<!-- eslint-disable vue/no-parsing-error -->
<template>
    <div class="main-container">

        <div class="back-route" @click.stop="router.push('/management/courses')">
            <i class="material-icons">keyboard_arrow_left</i><span>Volver</span>
        </div>


        <StudentsTable tableAt="courses" />


    </div>
</template>

<script>
import { onMounted } from 'vue-demi';
import StudentsTable from '@/components/StudentsTable.vue';
import { useRouter } from 'vue-router';


export default {
    components: {
    StudentsTable,
    },    
    setup() {
        const router = useRouter();


        onMounted(()=>{
        })

        return{
            router
        }

    },
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.back-route{
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 1px;
    font-weight: 600;
    font-size: 12px;
    color: $green;
    cursor: pointer;
    .material-icons{
        font-size: 17px;
    }
}

.disabled{
    opacity: .6;
    cursor: default !important;
}

.main-container {
    padding: 8px;
    background: #fff;
    min-height: fit-content;
}

.selected__actions{
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    justify-content: flex-end;
    height: 37px;
    button{
        border: 1px solid $green;
        border-radius: 44px;
        font-size: 16px;
        font-weight: 600;
        color: $green;
        padding: 8px 0;
        min-width: 149px;
        &:disabled{
            cursor: default;
        }
    }
}

.dropdown{
    &__items{
        padding: 8px 0;
        display: flex;
        flex-direction: column;
        gap: 6px;
        background: #fff;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        z-index: 2;
        font-size: 13px;
        font-weight: 600;
        border: none;
        li{
            padding: 4px 24px;
            cursor: pointer;
            &:hover{
                background: rgba(189, 228, 228, 0.5);
            }
        }
        @media screen and (max-width: 750px) {
            right: 0 !important;
        }
    }
}

.moveStudent{
    width: 100%;
    max-width: 460px;
    padding: 28px 40px;
    display: flex;
    flex-direction: column;
    gap: 28px;
    &__title{
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
    }
    &__datas{
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
    }
    &__data{
        font-size: 12px;
        font-weight: 400;
        strong{
            font-weight: 700;
        }
    }
}

.table__modal-options {
    position: absolute;
    top: 50px;
    right: 2px;
    min-width: 215px !important;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: #fff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    z-index: 8000;
    padding: 6px 0;
    >div {
        padding: 4px 22px;
        @include icon-and-text-container;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        padding: 4px 22px;
        &:hover {
            background: rgba(189, 228, 228, 0.5);
        }
    }
}

/* .modal-options{
    //position: absolute;
    //top: 100px;
    //right: 100px;
    padding: 22px 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: #fff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    z-index: 5000;
    margin-bottom: 10px;
    >div{
        padding: 4px 22px;
        @include icon-and-text-container;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        &:hover{
            background: rgba(189, 228, 228, 0.5);
        }
    }
} */

.management {
    &__noResults {
        display: grid;
        padding: 20px 0 20px 0;
        text-align: center;
        grid-column-start: 1;
        grid-column-end: 7;
    }

}

.create-new {
    margin-right: 8px;
    color: $green;
    font-weight: 600;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    .material-icons {
        font-size: 15px;
    }
}

.cohorte_data{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    >span{
        font-size: 18px;
        font-weight: 400;
        strong{
            font-weight: 400;
            color: $green;
        }
    }
}
.modal__inner{
    max-width: 420px;
}

.modal-add-student{
    position: relative;
    padding: 12px 24px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    border-radius: 10px;
    .close{
        position: absolute;
        top: 16px;
        right: 16px;
        cursor: pointer;
    }
    h4{
        padding-bottom: 4px;
        margin-top: -6px;
        font-weight: 700;
        font-size: 16px;
    }
    span{
        font-weight: 400;
        font-size: 13px;
    }
    .buttons{
        display: flex;
        justify-content: center;
        gap: 24px;
        padding-top: 16px;
        button{
            width: 152px;
            padding: 8px 0;
            @include icon-and-text-container;
            justify-content: center;
            border-radius: 44px;
            font-weight: 600;
            font-size: 16px;
            &:first-child{
                border: 1px solid $green;
                color: $green;
            }
            &:last-child{
                background: $green;
                color: #fff;
            }
        }
    }
}


.modal-certificate {

    .modal__inner {
        max-width: unset;
    }
    
    &__name {
        font-style: italic;
        color: $green;
        text-transform: capitalize;
        font-weight: 700;
    }
    .close{
        position: absolute;
        top: 16px;
        right: 16px;
        cursor: pointer;
    }
    h4{
        padding-bottom: 4px;
        font-size: 16px;
        text-align: center;
        font-weight: 400;
    }
    
    .buttons{
        display: flex;
        justify-content: center;
        gap: 8px;
        padding-top: 16px;
        button{
            min-width: 152px;
            padding: 8px 16px;
            @include icon-and-text-container;
            justify-content: center;
            border-radius: 44px;
            font-weight: 600;
            font-size: 16px;
            &:first-child{
                border: 1px solid $green;
                color: $green;
            }
            &:last-child{
                background: $green;
                color: #fff;
            }
        }
    }
}

.pills{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    .pill{
        padding: 6px 10px 6px 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 600;
        font-size: 13px;
        background-color: $whitegray;
        border: 1px solid #000;
        border-radius: 50px;
        min-width: 150px;
        gap: 12px;
        .material-icons-outlined{
            font-size: 16px;
            cursor: pointer;
        }
    }
}

.preregistrations {
    width: fit-content;
    max-width: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
    h1 {
        font-size: 25px;
        font-weight: 700;
    }

    .tabs {
        display: flex;
        margin: 30px 0;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);

        >div {
            height: 60px;
            width: 180px;
            @include flex-column;
            justify-content: center;
            font-size: 15px;
            font-weight: 600;

            &.--selected {
                color: $green;
                border-bottom: 2px solid $green;
            }
        }
    }

    .new-and-filter {
        position: relative;
        min-height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &__search{
            input{
                border: none;
                &::placeholder{
                    font-size: 12px;
                }
            }
            border: 1px solid $black;
            padding: 6px 18px;
            border-radius: 999px;
            display: flex;
            align-items: center;
            .material-icons-outlined{
                position: absolute;
                font-size: 14px;
                right: 18px;
            }
        }
        h3 {
            font-size: 20px;
        }

        &__btns {
            display: flex;
            gap: 16px;
            align-items: center;
            @media screen and (max-width: 750px) {
                @include flex-column;
                padding-bottom: 16px;
            }

            button {
                @include icon-and-text-container;
                font-size: 12px;
                &.open-filters {
                    border: 1px solid;
                    border-radius: 16px;
                    padding: 6px 18px;
                    font-weight: 400;
                    gap: 18px;
                    height: fit-content;

                    .material-icons {
                        font-size: 18px;
                    }
                }
            }
        }

        .modal-filters {
            position: absolute;
            top: 50px;
            padding: 8px 0;
            display: flex;
            flex-direction: column;
            gap: 6px;
            background: #fff;
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            border-radius: 10px;
            z-index: 2;
            font-size: 13px;
            font-weight: 600;

            div {
                padding: 4px 24px;
                cursor: pointer;

                &:hover {
                    background: rgba(189, 228, 228, 0.5);
                }
            }

            @media screen and (max-width: 750px) {
                right: 0 !important;
            }
        }

        .modal-country-filters {
            right: 126px;
        }

        .modal-coordinator-filters {
            right: 240px;
        }

        .modal-status-filters {
            right: 0;
        }
    }


    .table-pagination {
        border-radius: 10px;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    }

    @media(max-width:980px) {
        .table__container {
            overflow-x: auto;
        }
    }

    .table {
        width: 100%;
        position: relative;
        margin-top: 8px;
        padding: 16px;
        padding-bottom: 0;

        th, td {
            padding: 16px;
        }

        &__head {
            
            
            &__row {
                th {
                    // overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-weight: 600;
                    font-size: 14px;
                    text-align: left;


                    &.table__head__row__stage {
                    position: relative;

                    .material-icons-outlined{
                        font-size: 14px;
                    }
                    .stage-tooltip{
                        width: 200px;
                        position: absolute;
                        right: -36px;
                        padding: 18px 14px 26px 14px;
                        background: #BDE4E4;
                        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                        border-radius: 10px;
                        text-align: left;
                        font-size: 11px;
                        font-weight: 400;
                        z-index: 100;
                        h4{
                            padding-bottom: 4px;
                            font-size: 13px;
                            font-weight: 700;
                        }
                    }
                }
                }
            }
        }

        &__body {
            tr {
                position: relative;
                td {
                    max-width: 210px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size: 13px;
                    text-align: left;
                    border-bottom: 1px solid #eee;
                    
                    &.table__body__row__title {
                        font-weight: 600;
                    }

                    &.table__body__row__status{
                    padding-top: 4px !important;
                        span{
                            display: inline-block;
                            width: 100px;
                            padding: 4px 0;
                            border-radius: 50px;
                            font-size: 12px;
                            font-weight: 600;
                            text-align: center;
                            &.--Active, &.--Reactivated{
                                background-color: #EFE2EE;
                                color: #9E5498;
                            }
                            &.--Finished, &.--certificate{
                                color: #009696;
                                background: rgba(189, 228, 228, 0.50);
                            }
                            &.--Inactive{
                                background: rgba(255, 178, 63, 0.15);
                                color: #FFB23F;
                            }
                        }
                    }
                

                    &.table__body__row__options {
                        font-size: 12px;
                        font-weight: 600;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        position: relative;
                    }
                }
            }
        }

    }
    .pagination{
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 24px 16px;
        .prev-next{
            @include icon-and-text-container;
            font-size: 15px;
            font-weight: 600;
            color: $green;
            line-height: 20px;
            &:disabled{
                cursor: default;
            }
            .material-icons{
                font-size: 20px;
            }
        }
        .page{
            font-size: 15px;
            font-weight: 400;
            span{
                font-weight: 700;
            }
        }
    }


    .unsuscribeUser{
        display: flex;
        flex-direction: column;
        gap: 24px;
        max-width: 460px;
        padding: 0 40px;
        h3{
            font-weight: 700;
            font-size: 16px;
        }
        span{
            font-size: 14px;
        }
        &__buttons{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            gap: 24px;
            button{
                border: 1px solid $green;
                text-align: center;
                width: fit-content;
                display: flex;
                align-items: center;
                gap: 12px;
                border-radius: 999px;
                padding: 12px 18px;
                .material-icons-outlined{
                    font-size: 18px;
                }
                &:first-child{
                    color: $green;
                }
                &:last-child{
                    color: #fff;
                    background-color: $green;
                }
            }
        }
    }
}
.tooltip-icon {
    font-size: 16px;
    position: relative;
    top: 3px;
}
</style>